import PropTypes from 'prop-types';
import React, { lazy, useState } from 'react';
import RenderComponent from './RenderComponent';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const Filters = ({
  hasApiStatus,
  callback,
  history,
  fleetCompanyList,
  filterList,
  handleReset,
  values,
  setInitialValues,
  vehicleList,
}) => {
  const [validationError, setValidationError] = useState('');

  const handleSubmit = (fields) => {
    setValidationError('');
    const finalData = { ...fields, vehicle: fields.vehicle?.value };
    if (fields.vehicle?.value) {
      Object.keys(finalData).forEach((key) => !finalData[key] && delete finalData[key]);
      filterList(finalData);
    } else {
      setValidationError('Please select filter');
    }
  };

  const handleCancel = () => {
    handleReset();
    setInitialValues({
      vehicle: null,
    });
    setValidationError('');
  };

  return (
    <>
      <Form
        type="server"
        direction="row"
        initialValues={{ ...values }}
        className="CSAForms"
        RenderComponent={RenderComponent}
        handleOnSubmit={handleSubmit}
        handleOnCancel={handleCancel}
        customProps={{
          history,
          callback,
          hasApiStatus,
          validationError,
          fleetCompanyList,
          setInitialValues,
          vehicleList,
        }}
      />
    </>
  );
};

Filters.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default Filters;
